module.exports = __webpack_public_path__ + "img/icono-paso-a-paso-155x140.b051334a.png";